import { Link } from "react-router-dom";
import { Box, Container, Typography, Link as MuiLink, useTheme, useMediaQuery } from "@mui/material";
import { Android } from "@mui/icons-material";
import { PLAY_STORE_URL } from "../config/store";

const COMPANY_NAME = "Weps Technology";
const ADDRESS = "H.No. 383, Muzaffarabad, Saharanpur, Uttar Pradesh, India – 247129";

const Footer = () => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const currentYear = new Date().getFullYear();

  const linkSx = {
    color: "inherit",
    textDecoration: "none",
    "&:hover": { textDecoration: "underline" },
  };

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#1a1a2e",
        color: "rgba(255,255,255,0.85)",
        pt: 6,
        pb: 3,
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        {/* Top: Download + columns */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: isSmall ? "1fr" : "1fr auto auto auto",
            gap: 4,
            alignItems: "start",
            pb: 4,
            borderBottom: "1px solid rgba(255,255,255,0.12)",
          }}
        >
          {/* Download app */}
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: "white" }}>
              Download Treasure
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              <MuiLink
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  ...linkSx,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1.5,
                  color: "rgba(255,255,255,0.9)",
                  "&:hover": { color: "white" },
                }}
              >
                <Android sx={{ fontSize: 28 }} /> Google Play (Android)
              </MuiLink>
            </Box>
          </Box>

          {/* Product */}
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: "white" }}>
              Product
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <MuiLink component={Link} to="/about" sx={linkSx}>
                About
              </MuiLink>
              <MuiLink component={Link} to="/how-to-use" sx={linkSx}>
                How to Use
              </MuiLink>
              <MuiLink component={Link} to="/contact-us" sx={linkSx}>
                Contact Us
              </MuiLink>
              <MuiLink component={Link} to="/blog" sx={linkSx}>
                Blog
              </MuiLink>
            </Box>
          </Box>

          {/* Legal */}
          <Box>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: "white" }}>
              Legal
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <MuiLink component={Link} to="/privacy-policy" sx={linkSx}>
                Privacy Policy
              </MuiLink>
              <MuiLink component={Link} to="/terms-and-conditions" sx={linkSx}>
                Terms & Conditions
              </MuiLink>
            </Box>
          </Box>

          {/* Company */}
          <Box sx={{ maxWidth: 240 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2, color: "white" }}>
              {COMPANY_NAME}
            </Typography>
            <Typography variant="body2" sx={{ lineHeight: 1.6, color: "rgba(255,255,255,0.8)" }}>
              {ADDRESS}
            </Typography>
          </Box>
        </Box>

        {/* Bottom: Copyright */}
        <Box
          sx={{
            display: "flex",
            flexDirection: isSmall ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isSmall ? "flex-start" : "center",
            gap: 2,
            pt: 3,
          }}
        >
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
            © {currentYear} {COMPANY_NAME}. All rights reserved.
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.6)" }}>
            Treasure – Know where your money goes.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
